import get from 'lodash/get';

import config from '../config';
import transformise from './translateTransformise';

function withConfig(fn) {
  const localeText = get(config, 'locale.text', {});
  return (...args) => fn(localeText, ...args);
}

/**
 * [translate]
 * @param  {Object} translations
 * @param  {String} key
 * @return {string}
 *
 * */

export function translate(translations, key) {
  const translation = translations[transformise(key)];
  if (translation) {
    return translation;
  }
  // console.error('Cannot find translation for', key, transformise(key));
  return key;
}

export default withConfig(translate);
